import { render } from "./StaffProfit.vue?vue&type=template&id=2580f406&scoped=true"
import script from "./StaffProfit.vue?vue&type=script&lang=js"
export * from "./StaffProfit.vue?vue&type=script&lang=js"

import "./StaffProfit.vue?vue&type=style&index=0&id=2580f406&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2580f406"]])

export default __exports__